import { OTPCheckDto } from 'src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto';
import { SendOTPDtoImpl, SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { LoginProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { BuyToneDto } from '../../../../core/dto/buytone/buytonedto';
import { BuyToneResponse } from '../../../../core/api/tune/buytune/buytoneresponse';
import { BuyToneRequestImpl } from '../../../../core/api/tune/buytune/buytonerequest';
import { AddNameTuneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametunerequest';
import { AddNameTuneResponse } from 'src/com/sixdee/crbtportal/core/api/nametune/addnametuneresponse';
import { AddNameTuneDto } from 'src/com/sixdee/crbtportal/core/dto/addnametune/addnametunedto';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { ToneProcessorFactory } from '../../../../core/processorfactory/toneprocessorfactory';
import { ConfirmOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/confirmotp/confirmotpdto';
import { ConfirmOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotpresponse';
import { ConfirmOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotprequest';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';


export interface OTPVerificationAPIModel extends APIModel
{
    otpCheck(createAccountOtpCheckDto: OTPCheckDto): void;
    resendOtp(msisdn: string): void;
    resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void ;
    buyTone(buyToneDto: BuyToneDto): void;
    buyNameTone(buyToneDto: AddNameTuneDto): void ;

}

export class OTPVerificationAPIModelImpl extends APIModelImpl implements OTPVerificationAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;
    private toneProcessor: ToneProcessorFactory;
    
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
        this.toneProcessor = this.getAPIProcesssorFactory().getToneProcessorFactory();
    }

    resendOtp(msisdn: string): void 
    {
        let sendotpdto = new SendOTPDtoImpl();
        sendotpdto.setMsisdn(msisdn);

        this.resendOtpFunc(sendotpdto);
    }

    otpCheck(createAccountOtpMsgDto: OTPCheckDto): void 
    {
        let confirmOtp = new ConfirmOTPDtoImpl();
        confirmOtp.setMsisdn(createAccountOtpMsgDto.getMsisdn());
        confirmOtp.setLanguage(createAccountOtpMsgDto.getLanguage());
        confirmOtp.setLanguage(createAccountOtpMsgDto.getOtp());

        this.loginProcessorFactory.confirmOtp()
        .success((otpCheckResponse : ConfirmOTPResponse)=>
        {
            this.getAPIModelHandler().onSuccess(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        })
        .failure((otpCheckResponse : ConfirmOTPResponse)=>
        {
            this.getAPIModelHandler().onFailure(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        }).execute(new ConfirmOTPRequestImpl(createAccountOtpMsgDto));    
    }

     resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void 
    {
        let generateOtp = new GenerateOTPDtoImpl();
        generateOtp.setMsisdn(createAccountSendOtpDto.getMsisdn());
  
          this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                  .success((generateOTPResponse : GenerateOTPResponse)=>
                  {
                      this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                      generateOTPResponse.getDescription(), generateOTPResponse);
                  })
                  .failure((generateOTPResponse : GenerateOTPResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                           generateOTPResponse.getDescription(), generateOTPResponse);
  
                  }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
    buyTone(buyToneDto: BuyToneDto): void 
    {
        this.toneProcessor.getBuyToneNonLoggedUserAPIProcessor()
        .success((buyResponse : BuyToneResponse)=>
         {
            this.getAPIModelHandler().onSuccess(buyResponse.getAPIFeature(), 
            buyResponse.getDescription(), buyResponse);
         })
       .failure((buyResponse : BuyToneResponse)=>
       {
           this.getAPIModelHandler().onFailure(buyResponse.getAPIFeature(), 
           buyResponse.getDescription(), buyResponse);
         })
       .execute(new BuyToneRequestImpl(buyToneDto));
    }

    buyNameTone(buyToneDto: AddNameTuneDto): void 
    {
      this.getAPIProcesssorFactory().getNameTuneProcessorFactory()
                   .getAddNameTuneNonLoggedInAPIProcessor()
                .success((addNameTuneResponse: AddNameTuneResponse)=>
                {
                  console.log("NAMETUNE SUCCESS ######################################################3");
                   this.getAPIModelHandler().onSuccess(addNameTuneResponse.getAPIFeature(), 
                   addNameTuneResponse.getDescription(), addNameTuneResponse);
                })
                .failure((addNameTuneResponse: AddNameTuneResponse)=>
                {
                    this.getAPIModelHandler().onFailure(addNameTuneResponse.getAPIFeature(), 
                    addNameTuneResponse.getDescription(), undefined);
                })
                .execute(new AddNameTuneRequestImpl(buyToneDto));
    }
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/otpverification/otpverificationapimodel.tsx